import { Component, OnInit } from '@angular/core';
import { AngularFirestore} from '@angular/fire/compat/firestore';

import {FormBuilder, FormGroup,Validators} from "@angular/forms";
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import * as firebase from 'firebase/app';
import { NavbarService } from '../../core/navbar.service';
import { SeoService } from '../../core/seo.service';

@Component({
  selector: 'app-volunteer',
  templateUrl: './volunteer.component.html',
  styleUrls: ['./volunteer.component.css']
})
export class VolunteerComponent implements OnInit {

  volunteerForm: FormGroup;
  loading = false;
  success = false;

  submittedData = {
    name: '',
    email: '',
    role: ''
  };

  constructor(
    private fb: FormBuilder,
    private afs: AngularFirestore, 
    public nav: NavbarService,
    private seo: SeoService
  ) { }

  ngOnInit() {
    this.nav.show();
    this.seo.updateTags({
      title: 'Volunteer Signup',
      description: 'Volunteer at the Bayou Lacombe Museum. Support docent tours, native gardens, community education, and local heritage preservation in St. Tammany Parish.',
      url: '/volunteer'
    });
    this.volunteerForm = this.fb.group({
      name: ['', [
        Validators.required,
        Validators.pattern('[a-zA-Z .-]*'),
      ]],
      email: ['', [
        Validators.required,
        Validators.email
      ]],
      volunteer: ['Daily', [
        Validators.required
      ]]
    });
  }

  get name() {
    return this.volunteerForm.get('name');
  }

  get email() {
    return this.volunteerForm.get('email');
  }

  get volunteer() {
    return this.volunteerForm.get('volunteer');
  }

  get mailtoLink(): string {
    const volName = this.submittedData.name || this.volunteerForm.value.name || '';
    const volEmail = this.submittedData.email || this.volunteerForm.value.email || '';
    const volRole = this.submittedData.role || this.volunteerForm.value.volunteer || 'General Volunteering';
    const subject = encodeURIComponent(`Volunteer Interest - Bayou Lacombe Museum (${volName})`);
    const body = encodeURIComponent(
      `Hello Bayou Lacombe Museum,\n\nI would love to volunteer with the museum!\n\nName: ${volName}\nEmail: ${volEmail}\nArea of Interest: ${volRole}\n\nPlease let me know when your next orientation or volunteer meeting takes place.\n\nBest regards,\n${volName}`
    );
    return `mailto:bayoulacombemuseum@gmail.com,info@bayoulacombemuseum.com?subject=${subject}&body=${body}`;
  }

  async onSubmit() {
    if (this.volunteerForm.invalid) return;

    this.loading = true;
    const formValue = {
      name: this.volunteerForm.value.name,
      email: this.volunteerForm.value.email,
      volunteer: this.volunteerForm.value.volunteer,
      createdAt: new Date()
    };

    this.submittedData = {
      name: this.volunteerForm.value.name,
      email: this.volunteerForm.value.email,
      role: this.volunteerForm.value.volunteer
    };

    try {
      await this.afs.collection('volunteer').add(formValue);
      this.success = true;
    } catch (err) {
      console.error('Firestore volunteer save error:', err);
      // Resilience: allow applicant to complete via direct email
      this.success = true;
    } finally {
      this.loading = false;
    }
  }
}
